<template>
    <section class="flex flex-col items-stretch mb-4 px-4 md:px-8">
        <div class="flex flex-wrap justify-center gap-4 w-full">
            <div class="grid items-center min-w-[220px] flex-1 md:flex-none">
                <label class="text-left" for="month">Mes</label>
                <Dropdown 
                    id="month" 
                    v-model="selectedMonth" 
                    :options="months" 
                    optionLabel="name" 
                    placeholder="Selecciona un mes" 
                    class="w-full" 
                    :disabled="disabled"
                />
            </div>
            <div class="grid items-center min-w-[220px] flex-1 md:flex-none">
                <label class="text-left" for="year">Año</label>
                <Dropdown 
                    id="year" 
                    v-model="selectedYear" 
                    :options="years" 
                    optionLabel="name" 
                    placeholder="Selecciona un año" 
                    class="w-full" 
                    :disabled="disabled"
                />
            </div>
            <div class="grid items-center min-w-[220px] flex-1 md:flex-none">
                <label class="text-left" for="company">Empresa</label>
                <Dropdown 
                    id="company" 
                    v-model="selectedCompany" 
                    :options="companies" 
                    optionLabel="name" 
                    placeholder="Selecciona una empresa" 
                    class="w-full" 
                    :disabled="disabled"
                />
            </div>
            <div class="grid items-center min-w-[220px] flex-1 md:flex-none">
                <label class="opacity-0" for="show-btn">Acción</label>
                <Button id="show-btn" label="Mostrar" @click="fillTable" :disabled="disabled"></Button>
            </div>
        </div>
    </section>

    <section class="grid justify-center mb-4 px-4 md:px-8" v-show="uninvoicedReport.length > 0">
        <div class="card overflow-auto">
            <DataTable 
                :value="uninvoicedReport" 
                stripedRows
                showGridlines 
                scrollable
                scrollHeight="700px"
                tableStyle="min-width: 30rem" 
                class="min-w-full facturacion-pendiente-table"
            >
                <Column field="name" header="Cliente">
                    <template #body="{data}">
                        <span :class="{'green-cell': data.level === 0, 'orange-cell': data.level === 1, 'red-cell': data.level === 2}">
                            {{ data.name }}
                        </span>
                    </template>
                </Column>
                <Column field="retainer" header="Iguala"></Column>
                <Column field="invoiced" header="Facturado"></Column>
                <Column field="pending" header="Pendiente"></Column>
            </DataTable>
        </div>
    </section>
</template>

<script>
import axiosInstance from '../axiosInstance';

export default {
    data() {
        return {
            selectedYear: {},
            years: [],
            selectedCompany: {},
            companies: [],
            selectedMonth: {},
            months: [],
            uninvoicedReport: [],
            disabled: false,
        }
    },
    methods: {
        async fetchUninvoicedData() {
            this.$emit("update-loading", true);
            this.disabled = true;
            let data = {};
            
            try {
                const holder = axiosInstance.post("/api/uninvoiced_holder", {
                    token: localStorage.getItem('token')
                });
                data = await holder;
            } catch(error) {
                console.error("fetchUninvoicedData: There was an error!", error);
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Error',
                    detail: 'Hubo un problema al consultar los datos iniciales.', 
                    life: 5000, 
                    group: 'topr' 
                });
            } finally {
                this.$emit("update-loading", false);
            }

            return data;
        },

        setInitialValues() {
            this.fetchUninvoicedData().then((response) => {
                if(response.status === 200) {
                    const { years, year, months, month, defaultCmp, companies } = response.data;

                    this.years = years.map((year) => {
                        return { name: year, value: year }
                    });

                    this.selectedYear = { name: year, value: year };

                    this.months = months.map((elem, index) => {
                        return { name: elem, value: index }
                    });

                    this.selectedMonth = this.months[month];

                    this.selectedCompany = {
                        name: defaultCmp.data.name, 
                        id: defaultCmp.data.id
                    };

                    this.companies = companies.map((company) => {
                        return {
                            name: company.data.name,
                            id: company.data.id
                        }
                    });

                    this.disabled = false;
                } else {
                    console.warn("setInitialValues: There was a problem with the request.", response);
                    this.$toast.add({ 
                        severity: 'warn', 
                        summary: 'Aviso',
                        detail: 'Hubo un problema con la solicitud. Vuelve a intentarlo.', 
                        life: 5000, 
                        group: 'topr' 
                    });
                }
            });
        },

        async fetchUninvoicedReport() {
            this.$emit("update-loading", true);
            this.disabled = true;
            let data = {};
            
            try {
                const report = axiosInstance.post("/api/uninvoiced_report_data", {
                    token: localStorage.getItem('token'),
                    month: this.selectedMonth.value,
                    year: this.selectedYear.value,
                    company_id: this.selectedCompany.id,
                });
                data = await report;
            } catch(error) {
                console.error("fetchUninvoicedReport: There was an error!", error);
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Error',
                    detail: 'Hubo un problema al consultar los datos.', 
                    life: 5000, 
                    group: 'topr' 
                });
            } finally {
                this.$emit("update-loading", false);
                this.disabled = false;
            }

            return data;
        },

        fillTable() {
            this.fetchUninvoicedReport().then((response) => {
                if(response.status === 200) {
                    const data = response.data.data;
                    this.uninvoicedReport = data.map((elem) => {
                        return { 
                            name: elem.name,
                            level: elem.level,
                            invoiced: elem.invoiced != "" ? elem.invoiced : "0.00",
                            pending: elem.pending != "" ? elem.pending : "0.00",
                            retainer: elem.retainer != "" ? elem.retainer : "0.00"
                        }
                    });
                } else {
                    console.warn("fillTable: There was a problem with the request.", response);
                    this.$toast.add({ 
                        severity: 'warn', 
                        summary: 'Aviso',
                        detail: 'Hubo un problema con la solicitud. Vuelve a intentarlo.', 
                        life: 5000, 
                        group: 'topr' 
                    });
                }
            });
        }
    },
    mounted() {
        this.setInitialValues();
    }
}
</script>

<style scoped>
::v-deep(.p-datatable) {
    @apply rounded-lg overflow-hidden shadow;
}

::v-deep(.p-datatable thead tr th) {
    background-color: #0f1338 !important;
    color: white !important;
}

::v-deep(.p-datatable tbody tr td) {
    text-align: right;
}

::v-deep(.p-datatable tbody tr:nth-child(odd) td) {
    background-color: #f3f4f6 !important;
    color: #111827 !important;
}

::v-deep(.p-datatable tbody tr:nth-child(even) td) {
    background-color: #ffffff !important;
    color: #111827 !important;
}

::v-deep(.p-datatable tbody tr td:first-child) {
    text-align: left;
}

::v-deep(.p-datatable tbody tr td:first-child:has(.green-cell)) {
    /* background-color: #dcfce7 !important; */
    color: #166534 !important;
    font-weight: 600;
}

::v-deep(.p-datatable tbody tr td:first-child:has(.orange-cell)) {
    /* background-color: #fed7aa !important; */
    color: #d66400!important;
    font-weight: 600;
}

::v-deep(.p-datatable tbody tr td:first-child:has(.red-cell)) {
    /* background-color: #fecaca !important; */
    color: #ab0000 !important;
    font-weight: 600;
}
</style>

<style>
/* Custom button color for light mode */
html:not(.dark) #show-btn {
    background-color: #0f1338 !important;
    border-color: #0f1338 !important;
    color: white !important;
}

html:not(.dark) #show-btn:hover:not(:disabled) {
    background-color: #1a1f4d !important;
    border-color: #1a1f4d !important;
}

/* Custom button color for dark mode */
html.dark #show-btn {
    background-color: #D9D9D9 !important;
    border-color: #D9D9D9 !important;
    color: #0f1338 !important;
}

html.dark #show-btn:hover:not(:disabled) {
    background-color: #c4c4c4 !important;
    border-color: #c4c4c4 !important;
}

/* Override Arya-Blue theme colors for dropdowns in light mode only */
html:not(.dark) .p-dropdown:not(.p-disabled):hover {
    border-color: #0f1338 !important;
}

/* When dropdown is clicked and open */
html:not(.dark) .p-dropdown.p-inputwrapper-focus.p-overlay-open {
    border-color: #0f1338 !important;
    box-shadow: 0 0 0 0.1rem rgba(15, 19, 56, 0.8) !important;
}

/* When dropdown has focus and item is selected */
html:not(.dark) .p-dropdown.p-focus.p-inputwrapper-focus {
    border-color: #0f1338 !important;
    box-shadow: 0 0 0 0.1rem rgba(15, 19, 56, 0.8) !important;
}

.dark .facturacion-pendiente-table thead tr th {
    background-color: #D9D9D9 !important;
    color: #0f1338 !important;
}

.dark .facturacion-pendiente-table tbody tr td {
    color: white !important;
}

.dark .facturacion-pendiente-table tbody tr:nth-child(odd) td {
    background-color: #18181b !important;
    color: white !important;
}

.dark .facturacion-pendiente-table tbody tr:nth-child(even) td {
    background-color: #27272a !important;
    color: white !important;
}

.dark .facturacion-pendiente-table tbody tr td:first-child:has(.green-cell) {
    /* background-color: #166534 !important; */
    color: #9bffbe !important;
}

.dark .facturacion-pendiente-table tbody tr td:first-child:has(.orange-cell) {
    /* background-color: #9a3412 !important; */
    color: #ffc17b !important;
}

.dark .facturacion-pendiente-table tbody tr td:first-child:has(.red-cell) {
    /* background-color: #991b1b !important; */
    color: #ff7070 !important;
}
</style>